<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { getOrderUrl } from '@shared/lib/routes'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderOrderInvoice',
})

const route = useRoute()

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'orders', text: 'Orders', to: AppRoute.Orders, disabled: false },
  { id: 'order', text: `Order / ${route.params.id as string}`, to: getOrderUrl(Number(route.params.id)), disabled: false },
  { id: 'invoice', text: 'Customise invoice', to: null, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
